import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Sticky from "react-stickynode";
import { useTranslation } from "react-i18next";
import usFlag from "../../images/flags/us.png";
import frFlag from "../../images/flags/fr.png";
import itFlag from "../../images/flags/it.png";
const flagMap = {
  en: usFlag,
  fr: frFlag,
  it: itFlag,
};

const Header = () => {
  const location = useLocation();
  const { i18n, t } = useTranslation(); // ✅ Fix here
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedLang, setSelectedLang] = useState(
    localStorage.getItem("lang") || i18n.language || "fr"
  );

  const [isNavOpen, setNavOpen] = useState(false);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang);
    localStorage.setItem("lang", lang);
    setShowDropdown(false);
  };

  useEffect(() => {
    if (selectedLang && selectedLang !== i18n.language) {
      i18n.changeLanguage(selectedLang);
    }
  }, [selectedLang, i18n]);

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
      setSelectedLang(savedLang);
    }
  }, []);

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  return (
    <Sticky innerZ={999} enabled>
      <header className="site-header mo-left header navstyle2">
        <div className="sticky-header main-bar-wraper header-curve navbar-expand-lg">
          <div className="main-bar clearfix bg-primary">
            <div className="container clearfix">
              <div className="logo-header mostion">
                <Link to="/">
                  <img src={require("../../images/gargouri-logo.png")} alt="" />
                </Link>
              </div>

              <button
                className={`navbar-toggler navicon justify-content-end ${
                  isNavOpen ? "open" : ""
                }`}
                type="button"
                onClick={toggleNav}
                aria-expanded={isNavOpen}
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>

              <div
                className={`header-nav navbar-collapse justify-content-end ${
                  isNavOpen ? "show" : "collapse"
                }`}
                id="navbarNavDropdown"
              >
                <div className="logo-header d-md-block d-lg-none">
                  <Link to="/">
                    <img
                      src={require("../../images/gargouri-logo.png")}
                      alt=""
                    />
                  </Link>
                </div>
                <ul className="nav navbar-nav">
                  <li
                    className={
                      location.pathname === "/"
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/">
                      {t("header.home")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/plastics" ||
                      location.pathname.includes("/product-details")
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/plastics">
                      {t("header.plastics")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/metallics"
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/metallics">
                      {t("header.metallics")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/historique"
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/historique">
                      {t("header.history")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/about"
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/about">
                      {t("header.about")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/contact"
                        ? "active has-mega-menu"
                        : "has-mega-menu"
                    }
                  >
                    <Link to="/contact">
                      {t("header.contact")}
                      <i className="fa"></i>
                    </Link>
                  </li>
                </ul>
                <div className="dlab-social-icon ind-social">
                  {/* Social icons here */}
                </div>
                <div className="d-flex align-items-center ms-auto">
                  <div className="language-dropdown position-relative">
                    <button
                      onClick={() => setShowDropdown(!showDropdown)}
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "transparent",
                        border: "2px solid white",
                        borderRadius: "20px",
                        padding: "6px 12px",
                        color: "white",
                        fontWeight: 500,
                        fontSize: "14px",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={flagMap[selectedLang]}
                        alt={selectedLang}
                        style={{ width: 20, borderRadius: "5%" }}
                      />
                      {selectedLang === "en"
                        ? "English"
                        : selectedLang === "fr"
                        ? "Français"
                        : "Italiano"}
                    </button>

                    {showDropdown && (
                      <div
                        className="dropdown-menu show shadow"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          marginTop: "4px",
                          padding: "4px 0",
                          zIndex: 1000,
                        }}
                      >
                        {[
                          { code: "en", label: "English" },
                          { code: "fr", label: "Français" },
                          { code: "it", label: "Italiano" },
                        ].map(({ code, label }) => (
                          <button
                            key={code}
                            onClick={() => handleLanguageChange(code)}
                            className="dropdown-item d-flex align-items-center"
                            style={{
                              background: "none",
                              border: "none",
                              width: "100%",
                              textAlign: "left",
                              padding: "6px 12px",
                              fontSize: "14px",
                              gap: "8px",
                            }}
                          >
                            <img
                              src={flagMap[code]}
                              alt={label}
                              style={{ width: 20 }}
                            />
                            {label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Sticky>
  );
};

export default Header;
